import React, { useEffect } from 'react';
import api from './api/axios';
import AppRoutes from './Router/Routes';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useDispatch } from 'react-redux';
import { validateToken } from './redux/actions/validateAction';
import LinearLoading from './Components/reuse/LinearLoading';
import { useGetApiLoading } from './hooks/useLoadingState';

// Guard to avoid duplicate validateToken calls in React 18 StrictMode (dev only)
let hasValidatedOnBoot = false;

function App() {
  const dispatch = useDispatch();
  const isGetApiLoading = useGetApiLoading();
  
  useEffect(() => {
    // Check if there's a token in the URL
    const urlParams = new URLSearchParams(window.location.search);
    const urlToken = urlParams.get('token');
    
    if (urlToken) {
      // If there's a token in URL, don't validate existing token
      // The TokenLogin component will handle the URL token
      return;
    }
    
    // Set api default Authorization header on app boot if token exists
    const existingToken = localStorage.getItem('token');
    if (existingToken) {
      api.defaults.headers.common.Authorization = `Bearer ${existingToken}`;
    }

    if (!hasValidatedOnBoot) {
      hasValidatedOnBoot = true;
      dispatch(validateToken());
    }
  }, [dispatch]);

  return (
    <>
      {/* Global Linear Loading Bar for GET APIs */}
      <LinearLoading show={isGetApiLoading} />
      <AppRoutes />
      <ToastContainer position="top-right" autoClose={3000} hideProgressBar={false} newestOnTop closeOnClick pauseOnHover theme="light" />
    </>
  );
}

export default App;
